import React, { useMemo } from 'react';
import useMeasure from 'react-use-measure';

import { Box, Container, Flex, Heading } from '@brand/components';
import { Assistance, Economical, QualityCheck, TimeSaving } from '@brand/icons';

import { Reasons } from '@hoa/organisms';

import { useTrade, useTranslation } from '@hoa/hooks';

import { ContentType } from '@hoa/types';

const icons = [
  <Economical />,
  <QualityCheck />,
  <Assistance />,
  <TimeSaving />,
];

export const CategoryWhyJaimy = (): JSX.Element => {
  const { t } = useTranslation();
  const { tradeCategory } = useTrade();
  const [ref, bounds] = useMeasure();

  const offset = useMemo<number>(() => {
    if (typeof window === `undefined`) return 0;

    return window.innerWidth - bounds.right;
  }, [bounds]);

  const reasons = (
    t(`category:whyJaimy.items`, {
      returnObjects: true,
    }) as ContentType[]
  ).map((item, key) => ({
    ...item,
    icon: icons[key],
  }));

  return (
    <Box as="section" py={20} overflow="hidden">
      <Container ref={ref} pe={0}>
        <Heading as="h2" variant="h3" mb={10}>
          {t(`category:whyJaimy.title`, {
            trade: tradeCategory?.toLowerCase(),
          })}
        </Heading>
        <Flex mr={[0, null, -offset]}>
          <Box flex={[null, null, null, `0 0 65%`]}>
            <Reasons reasons={reasons} />
          </Box>
          <Box display={[`none`, null, null, `block`]} ml={[null, null, 4]}>
            <Box
              as="figure"
              borderTopLeftRadius="3xl"
              borderBottomLeftRadius="3xl"
              overflow="hidden"
            >
              <img
                src={`${process.env.NEXT_PUBLIC_CDN}/images/reasons-to-choose.jpg`}
                alt="Why Jaimy"
                loading="lazy"
              />
            </Box>
          </Box>
        </Flex>
      </Container>
    </Box>
  );
};
